import type { BackendApi } from '../backend/client'

/**
 * "Email me a link to continue on my computer" -- sends HTML the caller composed
 * to the authenticated member's own address. See openapi.yaml `emailMyself`.
 */
export function emailMyself(api: BackendApi, params: { subject: string; html: string }) {
  return api.emailMyself(params)
}

/**
 * Submits the in-app "Contact support" form (also used by the account-deletion
 * flow, which sends itself as a support ticket rather than a dedicated endpoint).
 */
export function submitSupportContact(
  api: BackendApi,
  params: { email: string; name: string; description: string; subject?: string | null },
) {
  return api.supportContact(params)
}
